import { createAction, props, union } from '@ngrx/store';

import { DataResponse } from '@fcom/common/interfaces';

export const setReports = createAction(
  '[ReportsActions] SetReports',
  props<{ clientId: string; dateRange: string; response?: DataResponse; error?: string }>()
);

const all = union({ setReports });

export type ActionsUnion = typeof all;
